// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3rpIc","card-title":"Card_card-title__uVZEt","card-body":"Card_card-body__1hMPN","align":"Card_align__2rBWZ"};